import { render, staticRenderFns } from "./Repairs.vue?vue&type=template&id=f548e35a&"
import script from "./Repairs.vue?vue&type=script&lang=js&"
export * from "./Repairs.vue?vue&type=script&lang=js&"
import style0 from "./Repairs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports